import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@pxl/models/contracts';
import { FeatureScreenInformationModel } from '@pxl/shared/generated';

export const featureScreenInformationResolver: ResolveFn<FeatureScreenInformationModel> = async () => {
    return await inject(UserService).getFeatureScreenInformation();
};
